import get from 'lodash/get'
import { isPsmFacilityUser } from '../../../van-shared/utils/utils'
import { ANALYTICS_EVENTS } from '../utils'

/**
 * Processes navigation items specifically for analytics tracking.
 *
 * This function is only used by getUserTrackingHandler to determine
 * the correct module names for tracking events like MODULE_VISITED.
 *
 * NOTE: Do not reuse elsewhere—it's intentionally tailored for analytics needs
 * and may produce unexpected results in other contexts.
 */

const getProcessedNavigationItems = (config, user) => {
  let navigationItems = { ...config.navigationItems }

  if (navigationItems.reports) {
    navigationItems = {
      ...navigationItems,
      // Add 'reporting' key for compatibility,since both counts (SL) and stock reports (PSM)
      // use 'reporting' as their base route
      reporting: { ...navigationItems.reports }
    }
  }

  if (isPsmFacilityUser(user)) {
    return {
      ...navigationItems,
      shipments: {
        ...navigationItems.shipments,
        title: 'Deliveries'
      }
    }
  }
  return navigationItems
}

export const getUserTrackingHandler = ({ config, user, events }) => {
  const {
    MODULE_VISITED,
    CREDIT_APPLICATION_VISITED,
    CREDIT_APPLICATION_SENT,
    CREDIT_CONTRACT_VISITED,
    CREDIT_CONTRACT_SIGNED
  } = ANALYTICS_EVENTS

  return {
    visitedModule: (data) => {
      const basePath = get(data, 'basePath')
      const PrevBasePath = get(data, 'PrevBasePath')
      const navigationItems = getProcessedNavigationItems(config, user)
      const navigationItem = navigationItems[basePath]

      if (navigationItem && basePath !== PrevBasePath) {
        const newdata = { module_name: navigationItem.title }
        events.track(MODULE_VISITED, newdata)
      }
    },
    openedCreditApplication: () => {
      events.track(CREDIT_APPLICATION_VISITED)
    },
    sentCreditApplication: (locationId) => {
      events.track(CREDIT_APPLICATION_SENT, {location_id: locationId})
    },
    openedCreditContract: () => {
      events.track(CREDIT_CONTRACT_VISITED)
    },
    signedCreditContract: () => {
      events.track(CREDIT_CONTRACT_SIGNED)
    }
  }
}
